import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledSharedNavBar = styled.nav`
  transition: transform ${({ theme }) => theme.Transition.Timing.In};
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  position: fixed;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
`;

export const StyledTopNavBar = styled(StyledSharedNavBar)`
  height: var(--global-navbar-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledBottomNavBar = styled(StyledSharedNavBar)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1fr;
  ${({ theme }) => css`
    @media (max-width: ${theme.Screen.Size.Large}px) {
      grid-template-rows: 2fr;
      grid-template-columns: repeat(2, 1fr);
    }
  `};
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  position: relative;
  width: 100%;
`;
